import { render, staticRenderFns } from "./WhatsApp.vue?vue&type=template&id=02379b44&scoped=true"
import script from "./WhatsApp.vue?vue&type=script&lang=js"
export * from "./WhatsApp.vue?vue&type=script&lang=js"
import style0 from "./WhatsApp.vue?vue&type=style&index=0&id=02379b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02379b44",
  null
  
)

export default component.exports